<template>
  <div class="part-container">
    <!-- 头部 -->
    <div class="part-header">
      <div class="header-title">相关视频</div>
      <div class="more-button" v-if="showMore" @click="handleMore">+ 更多</div>
   
  
   
    </div>

    <!-- 内容区域 -->
    <div class="videos-content">
      <!-- 视频网格 -->
      <div class="videos-grid" :class="{ 'no-data': !displayVideos || displayVideos.length === 0 }">
        <!-- 有视频数据时显示视频 -->
        <template v-if="displayVideos && displayVideos.length > 0">
          <div
            v-for="(video, index) in displayVideos.slice(0, 6)"
            :key="index"
            class="video-item"
            @click="handleVideoClick(video, index)"
          >
            <div class="video-wrapper">
              <img :src="video.coverUrl || video.coverOssKey" :alt="video.title" class="cover" />

              <!-- 左下角标题 -->
              <div class="video-overlay">
                <div class="video-name">{{ video.customName }}</div>
              </div>

              <!-- 右下角播放按钮 -->
              <img class="play-button" src="/assets/~/media/images/ai/play-icon.png" alt="播放" />
            </div>
          </div>
        </template>
        
        <!-- 无视频数据时显示整体占位符 -->
        <div v-else class="no-data-placeholder">
          <img src="/assets/~/media/images/ai/no-video.png" alt="暂无视频内容" class="no-data-image" />
          <p class="no-data-text">暂无视频内容</p>
        </div>
      </div>
    </div>

    <!-- 自定义 PC 视频预览弹窗 -->
    <div class="video-preview-cover" v-if="previewVisible">
      <div class="pop">
         <div class="caption-left">{{ previewVideo.customName }}</div>
        <div class="pop-video">
          <video
            v-if="previewVideo.ossKey"
            ref="previewVideoEl"
            class="preview-video"
            :src="previewVideo.ossKey"
            playsinline
            controls
            @play="onVideoPlay"
            @pause="onVideoPause"
            @ended="onVideoPause"
          />
          <!-- 中心播放按钮（暂停时显示） -->
          <img
            v-if="!isVideoPlaying"
            class="center-play"
            src="/assets/~/media/images/ai/play-icon.png"
            alt="播放"
            @click.stop="handleCenterPlay"
          />
         
        </div>
         <!-- 底部信息与导航 -->
          <div class="caption-bar"> 
            <div class="caption-right">
              <button class="nav-btn prev" :disabled="disablePrev" @click.stop="showPrev" aria-label="上一个">‹</button>
              <span class="counter">{{ displayIndex }}/{{ totalInPagePadded }}</span>
              <button class="nav-btn next" :disabled="disableNext" @click.stop="showNext" aria-label="下一个">›</button>
            </div>
          </div>
        <img
          class="error-icon"
          src="/assets/~/media/images/icon/close-white.png"
          alt="关闭"
          @click="handlePreviewClose"
        >
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DetailVideo',
  props: {
    // 视频数据列表（后端分页每页返回的数据）
    videos: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      previewVisible: false,
      previewVideo: {
        ossKey: '',
        customName: '',
      },
      currentIndex: 0,
      isVideoPlaying: false,
    };
  },

  // watch: {
  //   videos: {
  //     immediate: true,
  //     handler(newVal) {
  //       if (this.previewVisible && !this.previewVideo.ossKey && Array.isArray(newVal) && newVal.length > 0) {
  //         const first = newVal[0] || {};
  //         this.currentIndex = 0;
  //         this.previewVideo = {
  //           ossKey: first.ossKey || first.ossKey || '',
  //           title: first.title || '',
  //         };
  //         this.$nextTick(() => {
  //           const el = this.$refs.previewVideoEl;
  //           if (el) {
  //             try {
  //               el.pause();
  //               el.currentTime = 0;
  //             } catch (e) {}
  //           }
  //         });
  //       }
  //     }
  //   }
  // },
 
  computed: {
    displayVideos() {
      return this.videos;
    },
    showMore() {
      return Array.isArray(this.videos) && this.videos.length > 6;
    },
    totalInPage() {
      return (this.displayVideos && this.displayVideos.length) || 0;
    },
    displayIndex() {
      const idx = this.currentIndex + 1;
      return String(idx).padStart(2, '0');
    },
    totalInPagePadded() {
      return String(this.totalInPage).padStart(2, '0');
    },
    disablePrev() {
      return this.currentIndex <= 0 || this.totalInPage <= 0;
    },
    disableNext() {
      return this.totalInPage <= 0 || this.currentIndex >= this.totalInPage - 1;
    },
  },
  methods: {
    handlePageChange(p) {
      this.$emit('page-change', p);
    },
    handleVideoClick(video, index) {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关视频-第'+ (index+1) + '个视频', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关视频-第'+ (index+1) + '个视频');

      this.currentIndex = index;
      this.previewVideo = {
        ossKey: video.ossKey || video.ossKey,
        customName: video.customName || '',
      };
      this.previewVisible = true;
      this.$nextTick(() => {
        const el = this.$refs.previewVideoEl;
        if (el) {
          try {
            el.pause();
            el.currentTime = 0;
          } catch (e) {}
        }
      });
    },
    updatePreviewByIndex() {
      if (!this.totalInPage) return;
      const clamped = Math.max(0, Math.min(this.currentIndex, this.totalInPage - 1));
      this.currentIndex = clamped;
      const v = this.displayVideos[clamped] || {};
      this.previewVideo = {
        ossKey: v.ossKey || v.ossKey || '',
        customName: v.customName || '',
      };
      this.$nextTick(() => {
        const el = this.$refs.previewVideoEl;
        if (el) {
          try {
            el.pause();
            el.currentTime = 0;
          } catch (e) {}
        }
      });
      this.isVideoPlaying = false;
    },
    showPrev() {
      if (!this.totalInPage || this.disablePrev) return;
      this.currentIndex = this.currentIndex - 1;
      this.updatePreviewByIndex();
    },
    showNext() {
      if (!this.totalInPage || this.disableNext) return;
      this.currentIndex = this.currentIndex + 1;
      this.updatePreviewByIndex();
    },
    handleCenterPlay() {
      const el = this.$refs.previewVideoEl;
      if (el) {
        try { el.play(); } catch (e) {}
      }
    },
    onVideoPlay() {
      this.isVideoPlaying = true;
    },
    onVideoPause() {
      this.isVideoPlaying = false;
    },
    handlePreviewClose() {
      this.previewVisible = false;
      this.previewVideo = { ossKey: '', customName: '' };
      this.currentIndex = 0;
      this.isVideoPlaying = false;
    },
    handleMore() {
      _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-Details-多模态-相关视频- ”更多”按钮', 1]);
      stm_clicki("send",'event',window.location.href, "点击",  'question-Details-多模态-相关视频”更多”按钮');
      // 直接打开视频预览弹窗，从第7个视频开始
      if (this.videos.length > 6) {
        this.currentIndex = 6; // 从第7个视频开始（索引为6）
        this.updatePreviewByIndex();
        this.previewVisible = true;
      }
    },
  },
};
</script>
// ... existing code ...
<style lang="scss" scoped>
@import './style/part.css';

// 基础样式（移动端优先）
.part-header {
  height: calc(44 / 375 * 100vw);
  margin-bottom: calc(15 / 375 * 100vw);
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: calc(10 / 375 * 100vw) calc(16 / 375 * 100vw);



}
 
.header-title {
  color: #333333;
  font-size: calc(18 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-B-GB';
  padding-top: 0;
}

.videos-content {
  padding: 0 calc(16 / 375 * 100vw) calc(16 / 375 * 100vw);
}

/* 视频网格样式 - 2x2布局 */
.videos-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: calc(10 / 375 * 100vw);
  margin-bottom: 0;
  align-items: stretch;
}

/* 无数据时的整体占位符样式 */
.videos-grid.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  border-radius: 0;
  width: 100%;
  aspect-ratio: 66 / 48;
  height: auto;
}

.no-data-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.no-data-image {
  width: calc(80 / 375 * 100vw);
  height: calc(60 / 375 * 100vw);
  margin-bottom: calc(10 / 375 * 100vw);
  opacity: 0.5;
  object-fit: contain;
}

.no-data-text {
  color: rgba(186, 192, 196, 1);
  font-size: calc(14 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  margin: 0;
}

.video-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.video-item:active {
  transform: scale(0.98);
}

.video-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 160 / 108;
  border-radius: calc(8 / 375 * 100vw);
  overflow: hidden;
  background-color: #000;
}

.cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.video-wrapper:active .cover {
  transform: scale(1.05);
}

/* 左下角标题覆盖层（始终显示） */
.video-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: calc(10 / 375 * 100vw);
}

.video-name {
  width: 70%;
  color: #fff;
  font-size: calc(12 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-R-GB';
  line-height: 1.4;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 右下角播放按钮 */
.play-button {
  position: absolute;
  right: calc(10 / 375 * 100vw);
  bottom: calc(8 / 375 * 100vw);
  width: calc(25 / 375 * 100vw);
  height: calc(25 / 375 * 100vw);
  object-fit: contain;
  pointer-events: none;
}

/* 更多按钮样式 */
/* 更多按钮样式 */
.more-button {
  background: #F5F7FA;
  border: 1px solid #F5F7FA;
  border-radius: calc(20 / 375 * 100vw);
  color: #37434C;
  padding: calc(8 / 375 * 100vw) calc(16 / 375 * 100vw); 
  font-size: calc(12 / 375 * 100vw);
  cursor: pointer;
  transition: all 0.3s ease;
}

.more-button:active {
  background: #E4E7ED;
  border-color: #DCDFE6;
}

/* 视频预览弹窗样式 - 移动端优化 */
.video-preview-cover {
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100000;
  justify-content: center;
  align-items: center;
}

.pop {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  height: 100vh;
}

.pop-video {
  transform: none;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 auto; 
  align-items: center;
  justify-content: center;
}

.preview-video {
  width: calc(100% - 40 / 375 * 100vw);
  height: auto;
  max-height: 70vh;
  object-fit: contain;
  background: #000;
  margin: 0 auto;
}

/* 中央播放按钮 */
.center-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(50 / 375 * 100vw);
  height: calc(50 / 375 * 100vw);
  cursor: pointer;
  user-select: none;
  object-fit: contain;
}

.error-icon {
  position: absolute;
  top: calc(0 / 375 * 100vw);
  right: calc(0 / 375 * 100vw);
  width: calc(24 / 375 * 100vw + 32 / 375 * 100vw);
  height: calc(24 / 375 * 100vw + 32 / 375 * 100vw);
  padding: calc(16 / 375 * 100vw);
  z-index: 10;
}

.caption-bar {
  position: absolute;
  bottom: calc(60 / 375 * 100vw);
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(15 / 375 * 100vw) calc(40 / 375 * 100vw);
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  pointer-events: none;
}

.caption-left {
  position: absolute;
  top: calc(40 / 375 * 100vw);
  color: #fff;
  font-size: calc(16 / 375 * 100vw);
  font-family: 'FZLanTingHeiS-B-GB';
  line-height: 1.4;
  pointer-events: auto;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  max-width: calc(100% - 40 / 375 * 100vw);
  margin-left: calc(20 / 375 * 100vw);
  word-wrap: break-word;
  text-align: left;
  margin-right: calc(20 / 375 * 100vw);
}

.caption-right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(10 / 375 * 100vw);
  width: 100%;
  pointer-events: auto;
}

.counter {
  color: rgba(255, 255, 255, 1);
  font-size: calc(14 / 375 * 100vw);
  margin: 0 calc(8 / 375 * 100vw);
}

.nav-btn {
  width: calc(48 / 375 * 100vw);
  height: calc(48 / 375 * 100vw);
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.3);
  color: #000000;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
}

.nav-btn:active {
  background-color: rgba(255, 255, 255, 0.5);
}

.nav-btn:disabled {
  background-color: rgba(255, 255, 255, 0.1);
  cursor: not-allowed;
}

/* 滚动条样式 */
.part-container::-webkit-scrollbar {
  width: calc(4 / 375 * 100vw);
}

.part-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: calc(2 / 375 * 100vw);
}

.part-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: calc(2 / 375 * 100vw);
}

/* 保留PC端基础样式以维持功能完整性 */
@media (min-width: 768px) {
  // .part-header {
  //   padding: calc(10 / 1920 * 100vw) 0;
  //   margin-bottom: calc(20 / 1920 * 100vw);
  // }
  // 基础样式（移动端优先）
// .part-header {
//   height: calc(44 / 375 * 100vw);
//   margin-bottom: calc(15 / 375 * 100vw);
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   padding: 0;
// }
  .videos-content {
    padding: 0;
  }
  
  .videos-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: calc(16 / 1920 * 100vw);
    margin-bottom: calc(20 / 1920 * 100vw);
  }
  
  .video-wrapper {
    border-radius: calc(8 / 1920 * 100vw);
  }
  
  .videos-grid.no-data {
    border-radius: calc(12 / 1920 * 100vw);
  }
  
  // .more-button {
  //   padding: calc(6 / 1920 * 100vw) calc(12 / 1920 * 100vw);
  //   border-radius: calc(4 / 1920 * 100vw);
  //   font-size: calc(14 / 1920 * 100vw);
  // }
}
</style>
// ... existing code ...